import { HTML_EXTENSION_ID, TAILWIND_EXTENSION_ID, ZEPLIN_EXTENSIONS_OWNER_USERNAME } from "../../../../foundation/constants";
import { WebappExtension } from "../../../../foundation/extensions";
import { ExtensionUser } from "../../../../foundation/extensions/extensionsTypes";

export function isOwnedByZeplin(extension: WebappExtension) {
    const { users }: { users: ExtensionUser[]; } = extension;
    const owner = users.find(({ role }) => role === "owner");
    if (!owner) {
        return false;
    }

    return owner.user?.username === ZEPLIN_EXTENSIONS_OWNER_USERNAME;
}

export function sortExtensions(extensions: WebappExtension[]) {
    const htmlExtensionIndex = extensions.findIndex(e => e._id === HTML_EXTENSION_ID);
    const tailwindExtensionIndex = extensions.findIndex(e => e._id === TAILWIND_EXTENSION_ID);

    if (htmlExtensionIndex > -1 && tailwindExtensionIndex > -1) {
        const tailwindExtension = extensions[tailwindExtensionIndex];
        extensions.splice(tailwindExtensionIndex, 1);
        extensions.splice(htmlExtensionIndex, 0, tailwindExtension);
        return extensions;
    }

    return extensions;
}
